<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{gameLog.company && gameLog.company.name }}
		</td>
		<td class="text-xs-center">
			{{gameLog.game && gameLog.game.name }}
		</td>
		<td class="text-xs-center">
			{{formatDate() }}
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/GameLog.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "game-log-row",
		props: {
			gameLog: {required: true}
		},
		mixins: [new RowMixin(types, "gamelog")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.gamelog).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.gamelog);
			},
			formatDate() {
				return moment.utc(this.gameLog.played_at).local().format(" HH:mm - D/M/Y");
			}
		}
	};
</script>

<style>


</style>
